<template>
  <div id="programEvent">
    <app-menu></app-menu>
    <admin-list-component
        :title="'Admin.menu.event' | staticTranslation"
        :add-text="'Admin.components.addEvent' | staticTranslation"
        edit-path="/admin/program/event/edit/"
        entity-name="event"
        :get-name-function="getName"
    />
  </div>
</template>

<script>
import AdminMenu from "@/components/admin/AdminMenu";
import AdminListComponent from "@/components/admin/AdminListComponent";

export default {
  name: "programEvent",
  components: {
    'app-menu': AdminMenu,
    'admin-list-component': AdminListComponent
  },
  methods: {
    getName: function (event) {
      return event.interprets.map(it => this.$options.filters.translation(it)).join(" & ") + " - "
          + this.$options.filters.date(event.date)
          + " ( " + this.$options.filters.translation(event.stage) + " )"
    }
  }
}
</script>

<style scoped>
#programEvent {
  background-color: white;
  min-height: 100vh;
  overflow: hidden;
}

</style>
